<script>
export default {
  name: "ForceLogoutDialog",
  data() {
    return {
      visible: false,
      loginTime: '',
      deviceInfo: '',
      location: '',
      ip: ''
    }
  },
  methods: {
    show(data) {
      this.loginTime = this.formatTime(data.timestamp)
      this.deviceInfo = data.device || '其他设备'
      this.location = data.location || '未知'
      this.ip = data.ip || '未知'
      this.visible = true
    },
    handleConfirm() {
      this.visible = false
      // 可以在这里添加确认后的回调逻辑
      if (this.$route.path !== '/home/index') {
        this.$router.push('/')
      }
      this.$emit('confirmed')
    },
    formatTime(timestamp) {
      if (!timestamp) return '未知时间'
      const date = new Date(timestamp)
      return `${date.getFullYear()}-${this.padZero(date.getMonth() + 1)}-${this.padZero(date.getDate())} ${this.padZero(date.getHours())}:${this.padZero(date.getMinutes())}`
    },
    padZero(num) {
      return num < 10 ? `0${num}` : num
    }
  }
}
</script>

<template>
  <el-dialog
      title="账号登录提醒"
      :visible.sync="visible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      width="450px"
      custom-class="force-logout-dialog"
  >
    <div class="dialog-content">
      <div class="warning-icon">
        <i class="el-icon-warning"></i>
      </div>
      <div class="message">
        <p>您的账号已于 <span class="time">{{ loginTime }}</span> 在</p>
        <p><span class="device">{{ deviceInfo }}</span> 登录</p>
        <p><span>登录ip：{{ ip }}</span></p>
<!--        <p><span>登录地点：{{ location }}</span></p>-->
        <p class="tip">如非本人操作，请及时修改密码</p>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button
          type="primary"
          @click="handleConfirm"
          class="confirm-btn"
      >
        确定
      </el-button>
    </span>
  </el-dialog>
</template>

<style scoped>
.dialog-content {
  display: flex;
  align-items: center;
  padding: 10px 20px;
}

.warning-icon {
  margin-right: 20px;
}

.warning-icon i {
  font-size: 40px;
  color: #E6A23C;
}

.message {
  font-size: 16px;
  line-height: 1.6;
}

.message .time {
  color: #409EFF;
  font-weight: bold;
}

.message .device {
  color: #F56C6C;
  font-weight: bold;
}

.message .tip {
  font-size: 14px;
  color: #909399;
  margin-top: 8px;
}

.confirm-btn {
  width: 120px;
}
</style>
<style>
/* 全局样式，因为el-dialog的content不在scoped范围内 */
.force-logout-dialog .el-dialog__header {
  border-bottom: 1px solid #EBEEF5;
  padding: 15px 20px;
}

.force-logout-dialog .el-dialog__title {
  font-size: 18px;
  color: #303133;
}

.force-logout-dialog .el-dialog__body {
  padding: 20px;
}
</style>